export default function auth({ to, next, store }) {
  const loginQuery = { name: "Login", query: { redirect: to.fullPath } };

  if (!store.getters.isProfileLoaded) {
    store
      .dispatch("fetchProfile")
      .then(() => {
        if (!store.getters.isProfileLoaded) {
          next(loginQuery);
        } else {
          next();
        }
      })
      .catch(() => {});
  } else {
    next();
  }
}
